import $Scriptjs from 'scriptjs'

var pickerApiLoaded = false;
var authApiLoaded = false;
var picker = undefined;
var token = undefined;
var parent_folder = undefined;
var callback = undefined;
var client_id = undefined;
var auth2_init = false

class googledrive_controller {

  openAuth (p_client_id, p_callback) {

    client_id = p_client_id;
    callback = p_callback;

    if (authApiLoaded) {
      gapi.load('auth2', this.onAuthApiLoad);
    } else {
      $Scriptjs('https://apis.google.com/js/api.js', () => {
        authApiLoaded = true
        gapi.load('auth2', this.onAuthApiLoad);
      })
    }    
  }

  openPicker (p_token, p_folder_path, p_callback) {

    token = p_token;
    parent_folder = p_folder_path;
    callback = p_callback;
    
    if (pickerApiLoaded) {
      gapi.load('picker', this.onPickerApiLoad);
    } else {
      $Scriptjs('https://apis.google.com/js/api.js', () => {
        pickerApiLoaded = true
        gapi.load('picker', this.onPickerApiLoad);
      })
    }    
  }

  onPickerApiLoad () {
    console.log(google.picker)

    var uploadView = new google.picker.DocsUploadView();
    uploadView.setParent(parent_folder)
    uploadView.setLabel("Nuevo Documento")

    picker = new google.picker.PickerBuilder()
      .setOAuthToken(token)
      .addView(uploadView)
      .setCallback(callback)
      .hideTitleBar()
      .build();

      console.log(picker)
    picker.setVisible(true);
  }

  onAuthApiLoad () {

    var result = {}

    try {

      var config = { client_id: client_id, scope: 'https://www.googleapis.com/auth/drive' }

      /* AQUI HAY UN ERROR CUANDO EL INIT FALLA POR PONER UN CLIEND_ID ERRONEO */

      // gapi.auth2.ExternallyVisibleError: gapi.auth2 has been initialized with different options. Consider calling gapi.auth2.getAuthInstance() instead of gapi.auth2.init().

      if (gapi.auth2.getAuthInstance() != null) {
        //console.log(gapi.auth2.getAuthInstance())
        //console.log(gapi.auth2.getAuthInstance().getInitialScopes())
        //console.log(gapi.auth2.getAuthInstance().currentUser)
        //console.log(gapi.auth2.getAuthInstance().isSignedIn)

        var googleAuth = gapi.auth2.getAuthInstance()
          googleAuth.grantOfflineAccess({ prompt: 'consent' }) 
            .then(function (resp) {

              console.log(resp);
              callback(resp)
            })
            .catch(function (error) {
              result.error = error
              console.log(error);
              callback(result)
            })

      } else {
        gapi.auth2.init(config)
          .then(() => {
            var googleAuth = gapi.auth2.getAuthInstance()
            googleAuth.grantOfflineAccess({ prompt: 'consent' }) 
              .then(function (resp) {
                console.log(resp);
                callback(resp)
              })
              .catch(function (error) {
                result.error = error
                console.log(error);
                callback(result)
              })
          })
          .catch(function (error) {
            result.error = error.details
            console.log(error);
            callback(result)
          })
      }
      
        

        /* NO BORRAR ESTO DE ABAJO */

      /*gapi.auth2.authorize(config,
        function (result) {

          console.log(result)

          console.log(gapi.auth2)
          console.log(gapi.auth2.getAuthInstance())

          //var googleAuth = gapi.auth2.getAuthInstance()
          gapi.auth2.grantOfflineAccess({ prompt: 'select_account' }) 
            .then(function (resp) {
              console.log(resp)
              callback(resp)
            })
            .catch(function (error) {
              console.log(error)
              callback({ error: error })
            })
            
          //callback(result)
        });*/

    } catch (error) {
      result.error = error
      callback(result)
    }

  }

}

export default new googledrive_controller("", "", "");